import IntroDialog from "./IntroDialog";
import LoadingView from "./LoadingView";

export default function LoadingScreen({}: {}) {
  return (
    <IntroDialog>
      <LoadingView />
    </IntroDialog>
  );
}
